import {ItemPath} from '../dtos/ItemDto';
import {AuctionsWithBids, UserInfo, UserWithId} from '../dtos/UserDto';
import {cast} from '@joyrideautos/auction-utils/src/castUtils';

export function mapAuctionsWithBids(auctionsWithBids?: AuctionsWithBids): (ItemPath & {bidId: string})[] {
    if (!auctionsWithBids) {
        return [];
    }

    const regionIds = Object.keys(auctionsWithBids);
    return regionIds.reduce<(ItemPath & {bidId: string})[]>((result, regionId) => {
        const auctionIds = Object.keys(auctionsWithBids[regionId]);
        for (const auctionId of auctionIds) {
            const itemIds = Object.keys(auctionsWithBids[regionId][auctionId]);
            for (const itemId of itemIds) {
                const bidOrString = auctionsWithBids[regionId][auctionId][itemId];
                const bidId = typeof bidOrString === 'string' ? bidOrString : bidOrString.bidId;
                result.push({
                    regionId,
                    auctionId,
                    itemId,
                    bidId,
                });
            }
        }
        return result;
    }, []);
}

export const mapDBUserToUserInfo = (user: UserWithId): UserInfo => {
    const paymentInfo = user.settings?.paymentInfo ?? {};
    return {
        ...user,
        settings: {
            ...user.settings,
            paymentInfo: {
                ...paymentInfo,
            },
        },
        identityVerifiedByAdmin: user.identityVerifiedByAdmin,
        identityVerifiedByStripe: user.identityVerifiedByStripe,
        emailVerified: !!user.emailVerifiedAt,
        isAnonymous: false,
        phoneVerificationDate: user.phoneVerificationDate || undefined,
        phoneVerificationRequestId: user.phoneVerificationRequestId || undefined,
        phoneVerificationFor: user.phoneVerificationFor || undefined,
        phoneVerifiedAt: user.phoneVerifiedAt || undefined,
        auctionsWithBids: mapAuctionsWithBids(user.auctionsWithBids),
        failedDeposits: cast(
            Object.entries(user.failedDeposits ?? {}).reduce<Record<string, {item: string; paymentResultKey: string}>>(
                (failedDeposits, [itemKey, {paymentResultKey}]) => ({
                    ...failedDeposits,
                    [itemKey]: {item: itemKey, paymentResultKey},
                }),
                {}
            )
        ),
    };
};
